<template>
  <Modal v-on="$listeners" v-bind="$attrs" :large="true">
    <template v-slot:title><i class="fas fa-info-circle mr-2"></i> Help</template>
    <template v-slot:body>
      <div class="container info-modal">
        <div class="p-2">
          <h4>Linking to a (new) note</h4>
          <hr>
          <div class="py-1 d-flex align-items-center">
            <span class="btn btn-primary btn-circle ml-2 mr-4 flex-shrink-0">1</span>
            <h5 class="d-inline-block my-0 flex-shrink-1">
              Highlight
              <mark>word(s)</mark> with your
              <i class="far fa-keyboard pl-1 pr-1"></i> or
              <i class="fas fa-mouse-pointer pl-1"></i>
            </h5>
          </div>
          <div class="py-3 d-flex align-items-center">
            <div>
              <span class="btn btn-primary btn-circle ml-2 mr-4 flex-shrink-0">2</span>
            </div>
            <div class="flex-shrink-1">
              <h5 class="py-0">Create new note or link to existing one</h5>Use the
              <b>Contexted Bar</b>
              to enter the title of a new note, or search for an existing one
            </div>
          </div>
          <div class="py-1 d-flex align-items-center">
            <span class="btn btn-primary btn-circle ml-2 mr-4 flex-shrink-0">3</span>
            <h5 class="my-0 d-inline-block flex-shrink-1">Done!</h5>
          </div>
        </div>
        <div class="p-2">
          <h4>Styling & Formatting</h4>
          <hr>
          <div class="row my-1" v-for="formattingShortcut in formattingShortcuts" :key="formattingShortcut.shortcut">
            <div class="col-5 col-md-4" v-html="formattingShortcut.shortcut"></div>
            <div class="col" v-html="formattingShortcut.description"></div>
          </div>
        </div>
        <div class="p-2">
          <h4>Shortkeys</h4>
          <hr>
          <div class="row my-1" v-for="shortcut in shortcuts" :key="shortcut.shortcut">
            <div class="col-5 col-md-4" v-html="shortcut.shortcut"></div>
            <div class="col" v-html="shortcut.description"></div>
          </div>
        </div>

      </div>
    </template>
    <template v-slot:footer>
      <button type="button" class="btn btn-secondary" @click="$emit('close')">Close</button>
    </template>
  </Modal>
</template>
<script>
import Modal from '@/components/Modal'
import { trackEvent } from '@/utils/analytics'
export default {
  components: {
    Modal
  },
  data() {
    return {
      shortcuts: [{
        shortcut: '<b><span class="badge badge-light button-badge py-1">CTRL</span> + <span class="badge badge-light button-badge py-1">q</span></b>',
        description: 'Create new note'
      }, {
        shortcut: '<b><span class="badge badge-light button-badge py-1">CTRL</span> + <span class="badge badge-light button-badge py-1">.</span></b>',
        description: 'Go to root note'
      }, {
        shortcut: '<b><span class="badge badge-light button-badge py-1">CTRL</span> + <span class="badge badge-light button-badge py-1">SPACE</span></b>',
        description: 'Open search bar'
      }, {
        shortcut: '<b><span class="badge badge-light button-badge py-1">CTRL</span> + <span class="badge badge-light button-badge py-1">M</span></b>',
        description: 'Focus mode'
      }
      ],
      formattingShortcuts: [{
        shortcut: '<b># Header</b>',
        description: 'Level 1 header'
      }, {
        shortcut: '<b>## Header</b>',
        description: 'Level 2 header'
      }, {
        shortcut: '<b>#### Header</b>',
        description: 'Level 4 header'
      }, {
        shortcut: '<b><span class="badge badge-light button-badge py-1">CTRL</span> + <span class="badge badge-light button-badge py-1">b</span></b>',
        description: 'Make selected text <b>bold</b>'
      }, {
        shortcut: '<b><span class="badge badge-light button-badge py-1">CTRL</span> + <span class="badge badge-light button-badge py-1">i</span></b>',
        description: 'Make selected text <i>italic</i>'
      }, {
        shortcut: '<b><span class="badge badge-light button-badge py-1">CTRL</span> + <span class="badge badge-light button-badge py-1">u</span></b>',
        description: 'Make selected text <u>underlined</u>'
      }, {
        shortcut: '<b>* + <code>word(s)</code> + <span class="badge badge-light button-badge py-1">ENTER</span></b>',
        description: 'Make unordered list'
      }, {
        shortcut: '<b><code>`code`</code></b></div>',
        description: 'Format text as code'
      }, {
        shortcut: '<span class="badge badge-light button-badge py-1">CTRL</span> + <span class="badge badge-light button-badge py-1">ENTER</span>',
        description: 'Set focus to Contexted Bar'
      }]
    }
  },
  mounted() {
    trackEvent('show help modal', {
      eventCategory: 'app',
      eventAction: 'show_info'
    })
  },
  inheritAttrs: false
}
</script>
<style scoped lang="scss">
.info-modal >>> .button-badge {
  border: 1px solid #c1c1c1;
  color: #444444;
}
h4 {
  margin-bottom: 0;
}
hr {
  margin-top: 0.5rem;
}
mark {
  background-color: #3390ff;
  color: #fff;
}
.btn-circle {
  width: 1.5rem;
  height: 1.5rem;
  text-align: center;
  padding: 1px 0px 0px 1px;
  background-color: $contexted-blue!important;
  font-size: 0.8rem;
  font-weight: bold;
  border: 0;
  padding-top: 0.1rem;
  border-radius: 3rem;
}
.info-modal h4 {
  font-size: 1rem;
}
.info-modal h5 {
  font-size: 1rem;
  margin: 0;
  padding: 0;
}
.info-modal {
  font-size: 0.8rem;
}
.info-modal .fas,
.far {
  font-size: 1.1rem;
}
h5 {
  font-size: $h5-size;
  font-weight: $h5-weight;
  padding-bottom: 0px;
}
</style>
